<template>
  <b-container fluid v-if="displayType == ''">
    <b-row>
      <b-col align="left"><h3><router-link v-if="$route.query.status" :to="{ name: 'group', params: { id: $route.params.id } }">{{ name }}</router-link><template v-else>{{ name }}</template><span v-if="$route.query.status" class="text-muted"> &mdash; {{ nameForStatus(parseInt($route.query.status)) }}</span></h3></b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <elevators v-if="elevators && elevators.length > 0" :elevators="elevators" :elevators-loaded="loaded"></elevators>
      </b-col>
    </b-row>
  </b-container>

  <b-container fluid v-else-if="displayType == 'map' && mapState == 1"> 
    <b-row>
      <b-col>
        <elevators-map :elevators="elevators" :template="mapTemplate"></elevators-map>
      </b-col>
    </b-row>
  </b-container>

  <b-container v-else-if="displayType == 'block'">
    <b-row>
      <b-col class="center">
        <h1>{{ name }}</h1>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col sm="3" v-for="elevator in elevators" :key="elevator.id">
        <b-link :to="'/lifts/' + elevator.id">
        <b-container class="liftbox" :class="classForElevator(elevator)" fluid>
          <b-row class="liftbox-header">
            <b-col>
              <b>{{ elevatorName(elevator) }}</b>
            </b-col>
          </b-row>

          <b-row class="liftbox-bg">
            <b-col class="liftbox-content center">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="pos" v-if="elevator.position_label != ''">
                      {{ elevator.position_label }}
                    </b-col>
                    <b-col class="pos" v-else>
                      {{ elevator.position }}
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col class="status">
                      {{ nameForStatus(elevator.status) }}
                    </b-col>
                  </b-row>

                  <b-row class="mt-3">
                    <b-col>
                      Trips until maintenance: {{ elevator.stopsUntilService }}
                    </b-col>
                  </b-row>
                </b-col>

                <b-col class="mt-3 lift-image">
                  <b-img width="80%" :src="imageForElevator(elevator)" />
                </b-col>
              </b-row>

              <b-row class="mt-3" v-if="!elevator.escalator">
                <b-col>
                  <b-button v-if="elevator.evac" variant="danger" @click.stop.prevent="evacElevator(elevator)">START</b-button>
                  <b-button v-else variant="danger" @click.stop.prevent="evacElevator(elevator)">STOP</b-button>
                </b-col>
              </b-row>

            </b-col>
          </b-row>
        </b-container>
        </b-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

import api from './api.js'
import auth from './auth.js'
import moment from 'moment';

import Elevators from './Elevators.vue'
import ElevatorsMap from './ElevatorsMap.vue'

import formatter from './formatter.mixin.js';

export default {
  name: 'group',
  components: {
    'elevators': Elevators,
    'elevators-map': ElevatorsMap,
  },
  props: ['settings'],
  mixins: [formatter],
  data() {
    return {
      name: '',
      map_id: '',
      displayType: '',
      elevators: [],
      loaded: false,

      mapTemplate: '',
      mapState: 0,
    }
  },
  computed: {
  },
  methods: {
    evacElevator(elevator) {
      elevator.evac = !elevator.evac
      api.putEvacElevator(elevator.id, elevator.evac);
    },
    getGroup(id) {
      api.getGroup(id, group => {
        if(group.data) {
          this.name = group.data.name;
          this.map_id = group.data.map_id;
          this.displayType = group.data.display_type || '';
          this.elevators = _.orderBy(group.data.elevators, 'status', 'desc');
          this.loaded = true;

          if(this.displayType == 'map') {
            if(this.map_id == "") {
              return
            }
            var ep = axios.create({
              baseURL: "",
            })

          ep.get('/static/img/maps/' + this.map_id + '.svg')
            .then(res => {
              if(res.headers['content-type'] == 'image/svg+xml') {
                this.mapTemplate = res.data;
                this.mapState = 1;
              } else {
                this.mapState = -1;
              }
            })
            .catch(err => {
              this.mapState = -1;
            });
          }
        } else {
          this.name = '';
          this.elevators = [];
          this.loaded = true;
        }
      });
    },
    refresh() {
      this.getGroup(this.$route.params.id);
    },
  },
  created() { 
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
      this.refresh();
    }
    this.refresh();

    if(this.settings.refresh) {
      this.refreshTimer = setInterval(this.refresh, parseInt(this.settings.refresh));
    } else {
      this.refreshTimer = setInterval(this.refresh, 30000);
    }
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
}
</script>

<style>
tr {
  cursor: pointer;
}

.center {
  text-align: center;
}

.pos {
  font-size: 300%;
  font-weight: bold;
}

.status {
  font-weight: bold;
}

.liftbox {
  margin-bottom: 3em;
}

.liftbox-header {
  text-align: center;
  opacity: 1;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 1em;
  padding-bottom: 1em;
}

.liftbox-bg {
  opacity: .7;
  background-color: white;
  height: 100%;
}

.liftbox-content {
  opacity: 1;
  padding-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/Group.vue